<template>
  <div>
    <a-button
      type="primary"
      icon="edit"
      @click.prevent="$refs.modal.open"
    ></a-button>
    <modal ref="modal" />
  </div>
</template>

<script>
import Modal from './Modal.vue';

export default {
  name: 'entity-control',
  components: { Modal },
};
</script>
